export const findCityByAlias = (data, alias) => {
  for (const city of data) {
    if (city?.name?.toUpperCase() === alias?.toUpperCase()) {
      return city;
    }
  }
  return null;
};
